import { NavLink, Outlet } from 'react-router-dom';
import { ClientLogo } from './assets/icons/ClientLogo';
import { useTranslation } from './hooks/useTranslation';
import { useResolvedLandingVariant } from './hooks/useResolvedLandingVariant';
import { isNewUxVariant } from './models/landing/variant';
import { PostHogPageView } from './services/posthog/PageView';

//TODO crate Naavlink component + styles

const styles = {
  base: 'w-fit items-center justify-center text-text-link-default text-body-strong tablet:text-body-large-strong cursor-pointer active:text-text-link-active hover:text-text-link-active',
  focus:
    'focus:ring-3 focus:ring-border-focus-1 active:ring-0 focus:py-0 focus:outline-none focus:border-transparent rounded-radius-200 ',
  visited: 'visited:text-text-link-visited',
  iconClass: `transition-colors`,
  text: `flex flex-inline items-center active:rounded-md border-b active:border-transparent active:bg-bg-primary group-focus:border-transparent group-hover:border-transparent px-space-50`,
};

const Layout = () => {
  const { data } = useTranslation();
  const { variant } = useResolvedLandingVariant();

  return (
    <>
      <PostHogPageView />
      <div className="min-h-screen">
        <header className="mx-auto w-11/12 md:w-9/12 py-1">
          <div className="flex py-space-400 content-between justify-start items-center">
            <NavLink to="/">
              <ClientLogo />
            </NavLink>
          </div>
        </header>
        <main>
          <Outlet />
        </main>
        <footer className="w-full bg-gray-100 flex justify-center">
          <div className="w-11/12 md:max-w-9/12 gap-3 py-space-700">
            <ul className="pb-space-700 flex space-evenly items-center justify-center flex-col md:flex-row md:justify-between ">
              {data?.footerLinks
                // The new-UX (`-v1` / `-v2`) experiences drop the cookie-policy footer
                // link (DPO-approved 2026-08-27 — the site stores no cookies);
                // the live design keeps it, so both A/B arms match what was
                // approved for each.
                .filter(
                  (footerLink) => !(isNewUxVariant(variant) && footerLink.link === '/cookies'),
                )
                .map(
                  (
                    footerLink: {
                      text: string;
                      link: string;
                    },
                    index: number,
                  ) => (
                    <li key={index} className="mb-space-500">
                      <NavLink
                        className={`${styles.base} ${styles.visited} ${styles.focus}`}
                        to={footerLink.link}
                      >
                        {footerLink.text}
                      </NavLink>
                    </li>
                  ),
                )}
            </ul>
            <div className="flex flex-col gap-space-500 w-full text-center">
              {data?.additionalSmallPrint && <p>{data.additionalSmallPrint}</p>}
              <p>{data?.footerCopy}</p>
              <p>
                {new Date().getFullYear()} Domestic & General Group Limited. All rights reserved.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};
export default Layout;
